import { Link, NavLink, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import Logo from "./Logo";
import { ShoppingCart, LogOut, User, LayoutDashboard, Briefcase, Package } from "lucide-react";

export default function AppNavbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [count, setCount] = useState(0);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const { data } = await api.get("/cart");
        if (mounted) setCount(data?.count || 0);
      } catch (_) {}
    };
    load();
    const i = setInterval(load, 8000);
    return () => { mounted = false; clearInterval(i); };
  }, []);

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  const linkClass = ({ isActive }) =>
    `text-sm font-medium tracking-wide transition-colors ${isActive ? "text-brand-green" : "text-white/70 hover:text-white"}`;

  return (
    <header className="sticky top-0 z-30 backdrop-blur-xl bg-black/80 border-b border-brand-blue/40">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 h-16 flex items-center justify-between gap-4">
        <Link to="/app" data-testid="navbar-logo-link">
          <Logo size="sm" />
        </Link>
        <nav className="hidden md:flex items-center gap-7">
          <NavLink to="/app" end className={linkClass} data-testid="nav-catalog">Catalogue</NavLink>
          <NavLink to="/app/account" className={linkClass} data-testid="nav-account">Compte</NavLink>
          <NavLink to="/app/b2b" className={linkClass} data-testid="nav-b2b">B2B Pro</NavLink>
          {user?.role === "admin" && (
            <NavLink to="/app/admin" className={linkClass} data-testid="nav-admin">Admin</NavLink>
          )}
        </nav>
        <div className="flex items-center gap-3">
          <Link
            to="/app/cart"
            data-testid="navbar-cart-button"
            className="relative inline-flex items-center justify-center h-10 w-10 rounded-md border border-brand-blue/60 hover:border-brand-green/70 hover:bg-brand-navy/40 transition"
          >
            <ShoppingCart className="h-4 w-4 text-white" />
            {count > 0 && (
              <span className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] px-1 rounded-full bg-brand-green text-black text-[10px] font-bold flex items-center justify-center">
                {count}
              </span>
            )}
          </Link>
          <button
            onClick={handleLogout}
            data-testid="navbar-logout-button"
            className="hidden sm:inline-flex items-center gap-2 h-10 px-4 rounded-md text-sm font-semibold text-white/80 hover:text-white border border-brand-blue/60 hover:border-brand-green/70 transition"
            title="Déconnexion"
          >
            <LogOut className="h-4 w-4" />
            <span className="hidden md:inline">Déconnexion</span>
          </button>
        </div>
      </div>
      {/* mobile sub-nav */}
      <div className="md:hidden flex items-center justify-around border-t border-brand-blue/30 px-2 py-2 text-xs">
        <NavLink to="/app" end className={linkClass} data-testid="nav-mobile-catalog">
          <Package className="h-4 w-4 inline mr-1" />Catalogue
        </NavLink>
        <NavLink to="/app/account" className={linkClass} data-testid="nav-mobile-account">
          <User className="h-4 w-4 inline mr-1" />Compte
        </NavLink>
        <NavLink to="/app/b2b" className={linkClass} data-testid="nav-mobile-b2b">
          <Briefcase className="h-4 w-4 inline mr-1" />B2B
        </NavLink>
        {user?.role === "admin" && (
          <NavLink to="/app/admin" className={linkClass} data-testid="nav-mobile-admin">
            <LayoutDashboard className="h-4 w-4 inline mr-1" />Admin
          </NavLink>
        )}
      </div>
    </header>
  );
}
